export type DataPoint = {
  date: Date;
  value: number; // thousands
};

const months = Array.from({ length: 24 }, (_, i) => new Date(2025, i, 1));

const generateStreamingData = (base: number, variance: number, phase: number) =>
  months.map((date, i) => {
    const seasonalBoost = [0, 1, 11].includes(i % 12) ? 1.2 : 1;
    const wave = Math.sin((i + phase) / 3) * 0.15 + 1;
    const randomFactor = 1 + (Math.random() - 0.5) * variance;
    return {
      date,
      value: Math.round(base * seasonalBoost * wave * randomFactor)
    };
  });

export const GraphData = [
  {
    label: "Spotify",
    data: generateStreamingData(45000, 0.2, 0)
  },
  {
    label: "Apple Music",
    data: generateStreamingData(30000, 0.25, 1)
  },
  {
    label: "Deezer",
    data: generateStreamingData(12000, 0.3, 2)
  },
  {
    label: "Amazon",
    data: generateStreamingData(18000, 0.25, 3)
  },
  {
    label: "Youtube",
    data: generateStreamingData(35000, 0.3, 4)
  }
];

// {
//     label: 'Spotify',
//     data: [
//       { date: new Date('2025-01-01'), value: 5 },
//       { date: new Date('2025-02-01'), value: 7.2 },
//       { date: new Date('2025-03-01'), value: 6.1 },
//       { date: new Date('2025-04-01'), value: 8.5 },
//     ],
//   },
